/**
 * Company: SPHMedia
 * Description: [Home Cas banner widget]
 */
import { IS_PLAYWRIGHT_TEST } from "@helper/getEnvVariables";
import { ReactElement } from "react";

/**
 * CasBannerWidget
 * Description: Cas Banner widgets on home page
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export function CasBannerWidget({
  CasBannerWidgetContent = "",
}: {
  CasBannerWidgetContent: string | undefined;
}): ReactElement {
  return IS_PLAYWRIGHT_TEST === "true" ? (
    <></>
  ) : (
    <div
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: CasBannerWidgetContent }}
    />
  );
}
